<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal :title="form.id ? 'Task information' : 'Create Task'" :subtitle="form.id
      ? 'Fill in the information below to update task'
      : 'Fill in the information below to add task'
      " btnlefttext="Save Changes" btncentertext="Cancel" btnrighttext="" :leftloading="loading_add_story"
      :rightloading="false" :centerloading="false" :footerhidden="false" footer_padding="10px 18px 28px 28px"
      header_padding="28px 0px 0px 28px" body_padding="0px 28px" width="500px" :hiderightbtn="false"
      @onLeftClick="submitStory()" @onCenterClick="cancelModal">
      <template v-slot:right_header_options>
        <div class="task-item-options" v-if="form.id">
          <app-dialog title="Delete Task" ask="Are you sure you want to delete this task?" yesText="Delete"
            noText="Cancel" @onComfirm="deleteStory(value)">
            <button class="btn-delete">
              <img src="@/assets/admin-icon/trush.svg" /> Delete
            </button>
          </app-dialog>
          <button class="btn-done" v-if="form.column_id != 8">
            <input class="checkbox" @change="makeCompletedTask($event, value)" type="checkbox" />Completed
          </button>
        </div>
      </template>

      <div class="widget-modal-body-noscoll">
        <widgetInputWrapper title="Task*">
          <widgetTextarea placeholder="Type you task" v-model="form.task_name"></widgetTextarea>
        </widgetInputWrapper>

        <div class="row">
          <widgetInputWrapper title="Task type*">
            <TaskType v-model="form.task_type"></TaskType>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper :title="`Due date (${future_section_name})`">
            <div class="row">
              <datetime class="input-date" v-model="due_date" type="date" format="yyyy-MM-dd"
                :min-datetime="moment().toISOString()" :max-datetime="moment().add(6, 'months').endOf('month').toISOString()
                  " @close="predictColumn(due_date)" style="width: 100%">
                <span class="date-icon" slot="after" style="padding: 0px; margin-top: 3px; padding-right: 10px">
                  <img src="@/assets/admin-icon/calendar.svg" />
                </span>
              </datetime>
            </div>
          </widgetInputWrapper>
        </div>

        <widgetInputWrapper title="Account" checkbox="New Account" @onChecked="(response) => {
          form.create_account = response;
        }
          ">
          <searchSelectInput v-if="!form.create_account" url="/account/search" :miltiple="false" :hasPagination="true"
            placeholder="Search Account" v-model="story_account">

            <template v-slot:result="{ result }">
              <span class="search-account-item">{{
                result.name | validate
                }}</span>
            </template>

            <template v-slot:selected="{ selected }">
              <span class="selected-search-account-item">{{
                selected.name | validate
                }}</span>
            </template>
          </searchSelectInput>
          <widgetInput v-else v-model="form.account_name" type="text" placeholder="Enter account name"></widgetInput>
        </widgetInputWrapper>

        <widgetInputWrapper title="Contact" v-if="!form.create_account && story_account.added[0]">
          <searchSelectInput :url="`/contact/search/${story_account.added[0].id}`" :miltiple="true"
            :hasPagination="true" v-model="story_contact" placeholder="Search Contact">

            <template v-slot:result="{ result }">
              <span class="search-contact-item">{{ result.first_name | validate }}
                {{ result.last_name | validate }}</span>
            </template>

            <template v-slot:selected="{ selected }">
              <span class="selected-search-contact-item">{{
                selected.first_name | validate
                }}</span>
            </template>
          </searchSelectInput>
        </widgetInputWrapper>

        <div class="add-new-contact" v-if="form.create_account">
          <widgetInputWrapper title="New Contact">
            <div class="row">
              <widgetInput v-model="form.first_name" type="text" placeholder="First name"></widgetInput>
              <div class="h-spacer"></div>
              <widgetInput v-model="form.last_name" type="text" placeholder="Last name"></widgetInput>
            </div>
            <div class="v-spacer"></div>
            <div class="row">
              <widgetInput v-model="form.phone" type="text" placeholder="Phone"></widgetInput>
              <div class="h-spacer"></div>
              <widgetInput v-model="form.email" type="text" placeholder="Email"></widgetInput>
            </div>
          </widgetInputWrapper>
        </div>

        <widgetInputWrapper title="Responsible / Assigned">
          <searchSelectInput url="/company/search/manager" :miltiple="true" type="site" v-model="assigned"
            placeholder="Responsible">

            <template v-slot:result="{ result }">
              <span class="search-contact-item"><img width="20" v-if="result.profile_picture"
                  :src="$fullUrl('images/profiles/' + result.profile_picture)" />
                <img v-else width="20" src="@/assets/avatar.png" />
                {{ result.first_name | validate }}
                {{ result.last_name | validate }}</span>
            </template>

            <template v-slot:selected="{ selected }">
              <span class="selected-search-contact-item">
                <img width="20" v-if="selected.profile_picture"
                  :src="$fullUrl('images/profiles/' + selected.profile_picture)" />
                <img v-else width="20" src="@/assets/avatar.png" />
                {{ selected.first_name | validate }}</span>
            </template>
          </searchSelectInput>
        </widgetInputWrapper>



      </div>
    </widgetModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading_add_story: false,
      form: {
        id: null,
        team_id: null,
        column_id: null,
        task_name: "",
        task_type: "Task",
        account_id: null,
        account_added: [],
        account_removed: [],
        contacts_id: null,
        due_date: "",
        assigned: [],
        added: [],
        removed: [],
        contacts_added: [],
        contacts_removed: [],
        create_account: false,
        // New account
        account_name: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      },
      story_account: {
        added: [],
        removed: [],
      },
      story_contact: {
        added: [],
        removed: [],
      },
      assigned: {
        added: [],
        removed: [],
      },
      due_date: "",
      future_section_name: "Unscheduled",
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFieldsValue(vm.value);
    } else {
      vm.resetFormFields();
    }
  },
  watch: {
  },
  methods: {
    predictColumn(date) {
      let vm = this;
      var user_date = vm.moment(
        vm.moment(date).format("YYYY-MM-DD"),
        "YYYY-MM-DD"
      );
      var today = vm.moment(vm.moment().format("YYYY-MM-DD"), "YYYY-MM-DD");
      var number_days = user_date.diff(today, "days");
      var date_end_next_month = vm.moment().add(1, "months").endOf("month");
      var next_month_number_days = date_end_next_month.diff(today, "days");

      var date_end_next_six_month = vm.moment().add(6, "months").endOf("month");
      var next_six_month_number_days = date_end_next_six_month.diff(
        today,
        "days"
      );

      if (number_days == 0) {
        vm.future_section_name = "Today";
      } else if (number_days == 1) {
        vm.future_section_name = "Tomorrow";
      } else if (number_days > 1 && number_days <= 10) {
        vm.future_section_name = "Next 10 days";
      } else if (number_days > 10 && number_days < next_month_number_days) {
        vm.future_section_name = "Next Month";
      } else if (
        number_days > next_month_number_days &&
        number_days <= next_six_month_number_days
      ) {
        vm.future_section_name = "Next 6 Months";
      } else {
        vm.future_section_name = "Unscheduled";
      }
      vm.form.column_id = vm.getSectionId(vm.future_section_name);
    },
    deleteStory(item) {
      let vm = this;
      vm.$emit("delete", item);
    },
    makeCompletedTask(event, item) {
      let vm = this;
      vm.$emit("completed", event, item, (column_id) => {
        vm.form.column_id = column_id;
      });
    },
    setFieldsValue(task) {
      let vm = this;
      vm.form.id = task.id;
      vm.form.column_id = task.column_id;
      vm.form.task_name = task.name;
      vm.form.task_type = task.type;
      vm.form.account_id = task.account_id;
      vm.form.due_date = task.due_date;
      vm.form.create_account = false;
      vm.due_date = task.due_date
        ? vm.moment(task.due_date, "YYYY-MM-DD").toISOString()
        : "";
      vm.form.assigned = [];
      vm.assigned = {
        added: [],
        removed: [],
      };
      vm.story_account = {
        added: [],
        removed: [],
      };
      vm.story_contact = {
        added: [],
        removed: [],
      };
      vm.added = [];
      vm.removed = [];

      task.assignees.forEach((item) => {
        vm.assigned.added.push({
          id: item.id,
          first_name: item.first_name,
          last_name: item.last_name,
          profile_picture: item.profile_picture,
          on_update: true,
        });
      });

      if (task.account) {
        vm.story_account.added.push({
          on_update: true,
          ...task.account
        });
      }
      task.contacts.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.story_contact.added.push(item);
      });
    },
    resetFormFields() {
      let vm = this;
      vm.form.assigned = [];
      vm.assigned = {
        added: [],
        removed: [],
      };
      vm.story_account = {
        added: [],
        removed: [],
      };
      vm.story_contact = {
        added: [],
        removed: [],
      };
      vm.added = [];
      vm.removed = [];
      vm.form = {
        id: null,
        column_id: null,
        team_id: vm.form.team_id,
        task_name: "",
        task_type: "Task",
        account_id: null,
        account_added: [],
        account_removed: [],
        contacts_id: null,
        due_date: "",
        assigned: [],
        added: [],
        removed: [],
        contacts_added: [],
        contacts_removed: [],
        create_account: false,
        // New account
        account_name: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      };
    },
    submitStory() {
      let vm = this;
      // Account
      if (vm.story_account.added.length > 0) {
        if (!vm.form.id) {
          vm.form.account_id = vm.story_account.added[0].id;
          vm.form.account_added = vm.story_account.added;
        }
      }

      // Contact
      if (vm.story_contact.added.length > 0) {
        if (!vm.form.id) {
          vm.form.contacts_id = vm.story_contact.added.map((item) => {
            return item.id;
          });
          vm.form.contacts_added = vm.story_contact.added.map((item) => {
            return item.id;
          });
        }
      }
      if (vm.due_date) {
        vm.form.due_date = vm.due_date
          ? vm.moment(vm.due_date).format("YYYY-MM-DD")
          : "";
      } else {
        vm.form.due_date = "";
        vm.form.column_id = vm.getSectionId("Unscheduled");
      }

      // Assigned
      if (vm.assigned.added.length > 0) {
        vm.form.assigned = vm.assigned.added.map((item) => {
          return {
            id: item.id,
            first_name: item.first_name,
            last_name: item.last_name,
            profile_picture: item.profile_picture,
          };
        });
      }
      const rules = {
        task_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Task can not be empty";
          },
        },
        task_type: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Task type can not be empty";
          },
        },
        // due_date: {
        //   run: (value) => {
        //     if (value.length > 0) {
        //       return false;
        //     }
        //     return "Due date can not be empty";
        //   },
        // },
        // account_id: {
        //   run: (value) => {
        //     if (vm.form.create_account) {
        //       if (vm.form.account_name) {
        //         return false;
        //       } else {
        //         return "Please enter account name";
        //       }
        //     } else {
        //       if (value) {
        //         return false;
        //       } else {
        //         return "Please select account";
        //       }
        //     }
        //   },
        // },
        // contacts_id: {
        //   run: (value) => {
        //     if (vm.form.create_account) {
        //       if (
        //         vm.form.first_name &&
        //         vm.form.last_name &&
        //         vm.form.phone &&
        //         vm.form.email
        //       ) {
        //         return false;
        //       } else {
        //         return "Please fill all contacts information";
        //       }
        //     } else {
        //       if (value) {
        //         return false;
        //       } else {
        //         return "Please add some contacts";
        //       }
        //     }
        //   },
        // },
        assigned: {
          run: (value) => {
            if (vm.form.id) {
              return false;
            }
            if (value.length > 0) {
              return false;
            }
            return "Add some responsible";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.loading_add_story = true;
        if (!vm.form.id) {
          vm.$store
            .dispatch("TASK_ADD_NEW_STORY", vm.form)
            .then((response) => {
              vm.loading_add_story = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Task added successfully",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.loading_add_story = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Something went wrong, try again",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          // For assigned
          vm.form.added = vm.assigned.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return {
                id: item.id,
                first_name: item.first_name,
                last_name: item.last_name,
                profile_picture: item.profile_picture,
              };
            });
          vm.form.removed = vm.assigned.removed.map((item) => {
            return item.id;
          });

          // For account
          vm.form.account_added = vm.story_account.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item;
            });
          if (vm.form.account_added.length > 0) {
            vm.form.account_id = vm.form.account_added[0].id;
          } else {
            vm.form.account_id = null;
          }
          vm.form.account_removed = vm.story_account.removed.map((item) => {
            return item.id;
          });

          // For contacts
          vm.form.contacts_added = vm.story_contact.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item.id;
            });
          vm.form.contacts_removed = vm.story_contact.removed.map((item) => {
            return item.id;
          });
          if (vm.form.account_added.length == 0 && vm.form.account_removed.length > 0) {
            vm.form.contacts_removed = vm.story_contact.added
              .map((item) => {
                return item.id;
              });
          }

          vm.$store
            .dispatch("TASK_UPDATE_STORY", vm.form)
            .then((response) => {
              vm.loading_add_story = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Task updated successfully",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.loading_add_story = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Something went wrong, try again",
                type: "warn",
                duration: 3000,
              });
            });
        }
      }
    },
    cancelModal() {
      let vm = this;
      vm.$emit("close");
    },
    getSectionId(name) {
      let vm = this;
      let id = null;
      vm.columns.forEach((item) => {
        if (item.name == name) {
          id = item.id;
        }
      });
      return id;
    },
  },
  computed: {},
  created() { },
};
</script>

<style lang="scss" scoped>
.task-item-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px;
}

.widget-modal-body-noscoll {
  .input-group {
    position: relative;

    .task-search-reasult {
      position: absolute;
      height: 200px;
      overflow-y: auto;
      z-index: 9999;
      background: #fff;
      box-shadow: 0px 0px 10px #a8a8a8;
      width: 100%;
      top: 62px;

      .task-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        padding: 5px 10px;
        cursor: pointer;

        &:hover {
          background: rgb(241, 241, 241);
        }

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }
}

.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.input-date {
  background: #fff;
}
</style>
